import {COPYRIGHT} from "../../../administrator/src/Variable";

export let INITIATED_ID = 1;
export let ACTIVE_ID = 2;
export let INACTIVE_ID = 3;
export let ON_MAINTENANCE_ID = 4;

export let ON_PROGRESS = 1;
export let DONE = 2;
export let OPEN = 3;
export let POSTPONED = 4;
export let SUSPENDED = 5;
export let QC_RETURNED = 6;
export let QC_PROCESS = 7;

export let RELEASE_STATUS_TAKEN = 1
export let RELEASE_STATUS_PASS = 2
export let RELEASE_STATUS_NOT_PASS = 3
export let RELEASE_STATUS_POSTPONED = 4
export let RELEASE_STATUS_CLOSED = 5
export let RELEASE_STATUS_SUSPENDED = 6
export let RELEASE_STATUS_OPEN = 7


export let ASSEMBLY_STATUS_COLOR = {
    "ALL":"#e56ecb",
    "On Progress":"#c18c00",
    "Done":"#0d6c10",
    "Open":"#6983FB",
    "Postponed":"#FF4181",
    "Suspended":"#FF0839",
    "QC Returned":"#e56ecb",
    "QC Process":"#021c92",
}


export let RELEASE_VERIFICATION_STATUS_COLOR = {
    "ALL":"#e56ecb",
    "Taken":"#a87d11",
    "Pass":"#6983FB",
    "Not Pass":"#FF9803",
    "Postponed":"#FF4181",
    "Open":"#108989",
    "Closed":"#0d6c10",
    "Suspended":"#FF0839",
}

export let TYPE_INSPECTION = "INSPECTION";
export let TYPE_RELEASE_VERIFICATION = "RELEASE-VERIFICATION";

export let FORM_TYPES = [TYPE_INSPECTION, TYPE_RELEASE_VERIFICATION]
export let FORM_TYPE_OBJECTS = [
    {id:1, name:TYPE_INSPECTION},
    {id:2, name:TYPE_RELEASE_VERIFICATION}
    ]




export default {
    GOOGLE_RECAPTCHA_SITE_KEY: 'id.co.abacus.GOOGLE_RECAPTCHA_SITE_KEY#'+COPYRIGHT,
    PROCESS_LOADING : false,
    LANGUAGE:'LANGUAGE',
    DEFAULT_LANGUAGE:'en',
    GoodsItemStatuses : {
        TAGGED : {
            id:1,
            label:"Tagged"
        },
        REGISTERED : {
            id:2,
            label:"Registered"
        },
        PLACED : {
            id:3,
            label:"Placed"
        },
        TAKEN_OUT : {
            id:4,
            label:"Taken Out"
        },
        PUT_IN : {
            id:5,
            label:"Put In"
        },
        BORROWED : {
            id:6,
            label:"Borrowed"
        },
        RETURNED : {
            id:7,
            label:"Returned"
        },
        REMOVED_FROM_MACHINE : {
            id:8,
            label:"Removed From Machine"
        },
        MISSING : {
            id:9,
            label:"Missing"
        }
    },
    BorrowingOfItemStatuses : {
        ON_BORROW : {
            id:1,
            label:"Borrowed"
        },
        RETURNED : {
            id:2,
            label:"Returned"
        },
        REPLACED : {
            id:3,
            label:"Replaced"
        },
        REMOVED_FROM_MACHINE : {
            id:4,
            label:"Removed From Machine"
        },
        MISSING : {
            id:5,
            label:"Missing"
        }
    },


    SmartDeviceType:{
        TOOLBOX:  {
            "id": 1,
            "type": "Toolbox",
            "active": true
        },
        VENDING_MACHINE:  {
            "id": 2,
            "type": "Vending Machine",
            "active": true
        },
    }
}